import React from 'react';
import PropTypes from 'prop-types';

import styles from '../Search.scss';

function FormFieldAddon({ label, onClick, type, enabled }) {
    return (<div
        className={styles['form-field-add-on']}
        role="presentation"
        onClick={enabled ? onClick : null}
        data-action={`add-${type}`}
    >
        <span className={styles['form-action-button']}>
            <span className={enabled ? styles['form-btn-add'] : styles['form-btn-add-inactive']} />
            <span className={styles['form-text']}>
                {label}
            </span>
        </span>
    </div>)
}

FormFieldAddon.propTypes = {
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    type: PropTypes.string.isRequired,
    enabled: PropTypes.bool,
};

FormFieldAddon.defaultProps = {
    enabled: true,
};

export default FormFieldAddon;
